<script>
	const Q = require('q');
	const _ = require('underscore');
	const metadata = require('core/metadata');
	const productService = require('services/productService');
	const studentLibraryUtilities = require('utilities/studentLibraryUtilities');
	const getReadingList = studentLibraryUtilities.getReadingList;
	const getLibraryProductsBySKF = studentLibraryUtilities.getLibraryProductsBySKF;
	const getNewLibraryProducts = studentLibraryUtilities.getNewLibraryProducts;
	const getPopularLibraryProducts = studentLibraryUtilities.getPopularLibraryProducts;
	const getArticlesYouMightLike = studentLibraryUtilities.getArticlesYouMightLike;

	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const SL_LIST = analyticsUtilities.events.SL_LIST;

	const { assetUrl } = require('utilities/urlUtilities');

	// For Luke Kornet / Promotional Collection
	// TODO - replace with services
	const libraryGradeFilter = (product, grade) => {
		let libraryGrades = metadata.libraryGradeMap[grade];
		let allow = false;

		if (libraryGrades && product.grades) {
			allow = product.grades.some(g => libraryGrades[g]);
		}

		return allow;
	};

	module.exports = {
		components: {
			'multi-item-carousel': require('components/multi-item-carousel.vue').default,
			'library-product-card': require('components/library-product-card.vue').default,
			'load-mask': require('components/load-mask.vue').default,
			'text-to-speech-player-simple': require('components/text-to-speech-player-simple.vue').default
		},
		props: ['tts', 'loading'],
		modelData: [
			'libraryReadingList',
			'studentLibrarySettings',
			'popularLibraryProducts',
			'newLibraryProducts',
			'articlesYouMightLike',
			'userContext',
			'activeClass'
		],
		data() {
			return {
				readingListLoading: false,
				skfLoading: false,
				skfData: {},
				spotlightProducts: null,
				spotlightLoading: false
			};
		},
		computed: {
			viewLoading() {
				return this.loading || this.readingListLoading || this.skfLoading || this.spotlightLoading;
			},
			skf() {
				let studentLibrarySettings = this.studentLibrarySettings;
				let s = {};
				if (studentLibrarySettings && studentLibrarySettings.skf) {
					s = studentLibrarySettings.skf;
				}
				return s;
			},
			topicPanels() {
				let panels = [];
				let skf = metadata.skf;
				let skfMap = skf.reduce((acc, node) => {
					acc[node.rms_key] = node;
					return acc;
				}, {});
				let skfData = this.skfData;
				let skfKeys = Object.keys(skfData);

				if (skfKeys.length) {
					skfKeys.forEach(g => {
						let skfNode = skfMap[g];
						let title = skfNode.name;
						let data = skfData[g];
						if (title && data && data.hits && data.hits.length) {
							panels.push(
								_.assign({}, data, {
									title,
									rms_key: g
								})
							);
						}
					});
				}

				panels.sort((a, b) => {
					let nameA = (a.title || '').toLowerCase();
					let nameB = (b.title || '').toLowerCase();
					if (nameA < nameB) {
						return -1;
					} else if (nameA > nameB) {
						return 1;
					} else {
						return 0;
					}
				});
				return panels;
			},
			topTopicPanel() {
				let topicPanels = this.topicPanels;
				let panel = null;
				if (topicPanels && topicPanels.length) {
					panel = topicPanels[0];
				}
				return panel;
			},
			isTeacher() {
				return this.userContext && !this.userContext.classCode;
			},
			grade() {
				let activeClass = this.activeClass;
				let g = activeClass ? activeClass.g || activeClass.grade : null;
				return g;
			},
			spotlightNode() {
				let spotlightId = metadata.promoId;
				let node = null;

				if (spotlightId && metadata.allNodesById['_' + spotlightId]) {
					node = metadata.allNodesById['_' + spotlightId];
				}

				return node;
			},
			spotlightTitle() {
				let spotlightNode = this.spotlightNode;
				let title = null;

				if (spotlightNode && spotlightNode.name) {
					title = spotlightNode.name;
					if (spotlightNode.subtitle) {
						title += ': ' + spotlightNode.subtitle;
					}
				}
				return title;
			},
			spotlightProductsFiltered() {
				let spotlightProducts = this.spotlightProducts;
				let grade = this.grade;
				let filtered = [];

				if (spotlightProducts && grade && spotlightProducts.length) {
					filtered = spotlightProducts.filter(p => {
						return libraryGradeFilter(p, grade);
					});
				}
				return filtered;
			},
			spotlightThumbnail() {
				const spotlightNode = this.spotlightNode;

				if (spotlightNode) {
					return assetUrl(spotlightNode.thumbnailUrl);
				}

				return '';
			}
		},
		watch: {
			skf(val) {
				this.getSkf();
			},
			spotlightNode: {
				handler(p) {
					if (p && p.products && p.products.length) {
						this.spotlightProducts = null;
						this.spotlightLoading = true;
						let pids = p.products;
						let prms = pids.map(pid => {
							return productService.get(pid);
						});

						Q.all(prms)
							.then(products => {
								this.spotlightProducts = products;
							})
							.finally(() => (this.spotlightLoading = false))
							.done();
					}
				},
				immediate: true
			}
		},
		methods: {
			getSkf() {
				let prmsList = [];
				let skf = this.skf;
				let skfList = Object.keys(skf);
				let grade = this.grade || 191923;

				if (skfList && skfList.length) {
					this.skfLoading = true;
					skfList.forEach(s => {
						prmsList.push(getLibraryProductsBySKF(s, grade));
					});
				}
				return Q.all(prmsList)
					.then(list => {
						let data = {};
						skfList.forEach((i, idx) => {
							data[i] = list[idx];
						});
						this.skfData = data;
					})
					.finally(() => (this.skfLoading = false));
			},
			onReadingListCarouselClick() {
				fireEvent(SL_LIST, {
					loc: 'carousel'
				});
			}
		},
		mounted() {
			let grade = this.grade || 191923;
			this.readingListLoading = true;
			let prmsList = [getReadingList(), this.getSkf(), getNewLibraryProducts(grade), getPopularLibraryProducts(grade)];
			if (!this.isTeacher) {
				prmsList.push(getArticlesYouMightLike(grade));
			}
			Q.all(prmsList)
				.finally(() => (this.readingListLoading = false))
				.done();
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	.library-home {
		h2 {
			margin-top: 0;
			padding-top: 1.5rem;
		}

		.carousel-container {
			position: relative;
			background-color: $c-white;
			padding-bottom: 2rem;

			&.reading-list-carousel {
				background-color: $c-blue-lighter;
				position: relative;
				min-height: 20rem;

				&.empty {
					min-height: auto;
				}
			}

			.carousel-title {
			}

			.multi-item-carousel {
				min-height: 15rem;
			}

			.spotlight-card.library-product-card {
				width: 34rem;
				background-color: $c-blue-highlight;
				padding: 0.5rem;

				.spotlight-card-inner {
					display: flex;
					font-size: 0.75rem;

					.spotlight-image-container {
						width: 13rem;
					}

					.spotlight-body {
						flex: 1;
						padding-left: 0.5rem;
						p {
							font-weight: 500;
						}
					}
				}
			}
		}
	}
</style>
<template>
	<div class="library-home">
		<div class="reading-list">
			<div
				class="carousel-container"
				v-if="articlesYouMightLike && articlesYouMightLike.length">
				<load-mask v-if="viewLoading"></load-mask>
				<div class="wrapper">
					<h2 class="carousel-title">
						Reading Passages You Might Like
						<text-to-speech-player-simple
							v-if="tts"
							text="reading Passages You Might Like"></text-to-speech-player-simple>
					</h2>
					<multi-item-carousel>
						<library-product-card
							v-for="(item, index) in articlesYouMightLike"
							:key="item.id"
							:id="item.id"
							:carousel="'you-might-like'"
							:img="item.img_highres2"
							:img-alt="item.imgAlt"
							:title="item.title"
							:topics="item.libraryTopics"
							:article-index="index"
							:level="((item.canonicalGrade && [item.canonicalGrade]) || item.grades) | getGradeRangeString">
						</library-product-card>
					</multi-item-carousel>
				</div>
			</div>
			<div
				class="carousel-container"
				v-if="spotlightNode && spotlightProductsFiltered && spotlightProductsFiltered.length">
				<load-mask v-if="viewLoading"></load-mask>
				<div class="wrapper">
					<h2 class="carousel-title">
						{{ spotlightTitle }}
						<text-to-speech-player-simple
							v-if="tts"
							:text="spotlightTitle"></text-to-speech-player-simple>
					</h2>
					<multi-item-carousel>
						<div class="spotlight-card library-product-card">
							<div class="spotlight-card-inner">
								<div class="spotlight-image-container">
									<img
										class="spotlight-image"
										:src="spotlightThumbnail" />
								</div>
								<div
									class="spotlight-body"
									v-html="spotlightNode.description"></div>
							</div>
						</div>
						<library-product-card
							v-for="(item, index) in spotlightProductsFiltered"
							:key="item.id"
							:id="item.id"
							:carousel="'luke-kornet'"
							:grades="item.grades"
							:img="item.img_highres2"
							:img-alt="item.imgAlt"
							:title="item.title"
							:topics="item.libraryTopics"
							:article-index="index"
							:level="((item.canonicalGrade && [item.canonicalGrade]) || item.grades) | getGradeRangeString">
						</library-product-card>
					</multi-item-carousel>
				</div>
			</div>
			<div
				class="carousel-container"
				v-if="topTopicPanel">
				<load-mask v-if="viewLoading"></load-mask>
				<div class="wrapper">
					<h2 class="carousel-title">
						{{ topTopicPanel.title }}
						<text-to-speech-player-simple
							v-if="tts"
							:text="panel && panel.title"></text-to-speech-player-simple>
					</h2>
					<multi-item-carousel>
						<library-product-card
							v-for="(item, index) in topTopicPanel.hits"
							:key="item.id"
							:id="item.id"
							:carousel="topTopicPanel.rms_key"
							:grades="item.grades"
							:img="item.img_highres2"
							:img-alt="item.imgAlt"
							:title="item.title"
							:article-index="index"
							:level="((item.canonicalGrade && [item.canonicalGrade]) || item.grades) | getGradeRangeString">
						</library-product-card>
					</multi-item-carousel>
				</div>
			</div>
			<div
				class="carousel-container"
				v-if="popularLibraryProducts && popularLibraryProducts.length">
				<load-mask v-if="viewLoading"></load-mask>
				<div class="wrapper">
					<h2 class="carousel-title">
						Popular
						<text-to-speech-player-simple
							v-if="tts"
							text="Popular"></text-to-speech-player-simple>
					</h2>
					<multi-item-carousel>
						<library-product-card
							v-for="(item, index) in popularLibraryProducts"
							:key="item.id"
							:id="item.id"
							:carousel="'popular'"
							:grades="item.grades"
							:img="item.img_highres2"
							:img-alt="item.imgAlt"
							:title="item.title"
							:topics="item.libraryTopics"
							:article-index="index"
							:level="((item.canonicalGrade && [item.canonicalGrade]) || item.grades) | getGradeRangeString">
						</library-product-card>
					</multi-item-carousel>
				</div>
			</div>
			<div
				class="carousel-container"
				v-if="newLibraryProducts && newLibraryProducts.length">
				<load-mask v-if="viewLoading"></load-mask>
				<div class="wrapper">
					<h2 class="carousel-title">
						Recently Added
						<text-to-speech-player-simple
							v-if="tts"
							text="Recently Added"></text-to-speech-player-simple>
					</h2>
					<multi-item-carousel>
						<library-product-card
							v-for="(item, index) in newLibraryProducts"
							:key="item.id"
							:id="item.id"
							:carousel="'recent'"
							:grades="item.grades"
							:img="item.img_highres2"
							:img-alt="item.imgAlt"
							:title="item.title"
							:topics="item.libraryTopics"
							:article-index="index"
							:level="((item.canonicalGrade && [item.canonicalGrade]) || item.grades) | getGradeRangeString">
						</library-product-card>
					</multi-item-carousel>
				</div>
			</div>
			<div
				class="carousel-container"
				v-for="panel in topicPanels"
				:key="panel.title">
				<template v-if="panel.rms_key !== topTopicPanel.rms_key">
					<load-mask v-if="viewLoading"></load-mask>
					<div class="wrapper">
						<h2 class="carousel-title">
							{{ panel.title }}
							<text-to-speech-player-simple
								v-if="tts"
								:text="panel.title"></text-to-speech-player-simple>
						</h2>
						<multi-item-carousel>
							<library-product-card
								v-for="(item, index) in panel.hits"
								:key="item.id"
								:id="item.id"
								:carousel="panel.rms_key"
								:img="item.img_highres2"
								:img-alt="item.imgAlt"
								:title="item.title"
								:article-index="index"
								:level="((item.canonicalGrade && [item.canonicalGrade]) || item.grades) | getGradeRangeString">
							</library-product-card>
						</multi-item-carousel>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>
